// extracted by mini-css-extract-plugin
export default {"upgradeList":"style_upgradeList__QGoD-","lockedUpgrade":"style_lockedUpgrade__rjWzg"};